import React, { useState } from 'react';

import { IdcardOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown } from 'antd';

import type { UserProfile } from '@/entities/auth';

import { fetchCurrentUser } from '@/features/auth/api';
import { useDirectAuth } from '@/features/auth/model';
import { UserInfoModal } from '@/features/auth/ui/UserInfoModal';

import styles from './HeaderRight.module.css';

export const HeaderRight = React.memo(() => {
  const { logout } = useDirectAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userInfo, setUserInfo] = useState<UserProfile | null>(null);
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFetchUserInfo = async () => {
    setIsLoadingUserInfo(true);
    setError(null);
    setUserInfo(null);

    try {
      const fetchedUserInfo = await fetchCurrentUser();
      setIsModalOpen(true);
      setUserInfo(fetchedUserInfo);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '사용자 정보를 불러오는 데 실패했습니다.';
      setError(errorMessage);
    } finally {
      setIsLoadingUserInfo(false);
    }
  };

  const handleUserMenu = ({ key }: { key: string }) => {
    if (key === 'myInfo') {
      handleFetchUserInfo();
    } else if (key === 'logout') {
      logout();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setUserInfo(null);
    setError(null);
  };

  const menu = {
    items: [
      {
        key: 'myInfo',
        label: '내 정보',
        icon: <IdcardOutlined />,
      },
      {
        key: 'logout',
        label: '로그아웃',
        icon: <LogoutOutlined />,
        danger: true,
      },
    ],
    onClick: handleUserMenu,
  };

  return (
    <div className={styles.rightSection}>
      <Dropdown menu={menu} placement="bottomRight" trigger={['click']}>
        <Avatar icon={<UserOutlined />} className={styles.userAvatar} size={28} />
      </Dropdown>

      <UserInfoModal
        open={isModalOpen}
        onClose={handleCloseModal}
        userInfo={userInfo}
        isLoading={isLoadingUserInfo}
        error={error}
      />
    </div>
  );
});

HeaderRight.displayName = 'HeaderRight';
